import {ID, Response} from "../../../../../_metronic/helpers";

export type ElementModel = {
    id?: ID,
    title?: string,
    description?: string,
    picName?: string,
    postSortBy ? :PostSortBy ,
    take ? : number ,
    postTakeModel ? : PostTakeModel ,
    content ? : string ,
    catList ? : number [],
    productCatList ? :number[]
    elementType ?: elementType
}
export enum PostSortBy {
    LastUpdate,
    Popular,
    LastTag,
    none
}
export enum PostTakeModel {
    PerCategory,
    PerLastTime,
}
export const initialElementModel : ElementModel ={
    catList :[],
    postSortBy : PostSortBy.none ,
    postTakeModel : PostTakeModel.PerCategory,
    content : '',
    take : 0 ,
    description : '',
    title : '',
    picName : '' ,
    elementType : 0

}
 export enum elementType {
    post,
    product
}
export type AdvertisingQueryResponse = Response<Array<ElementModel>>

